export const BranchZeromatchingDashboards = {
  BranchZeromatchingDashboards: 
  {
    permissionsId:'20d90c59-cbc1-4844-7955-08dcaf947ea8',
    permissionsName:'Branch Zeromatching' , 
    componentsId:null,
    components:null
  }
} ;
